import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 15 9">
    <path
      fill="#555555"
      fillRule="evenodd"
      d="M7.373 6.047L12.964.455a1.053 1.053 0 0 1 1.49 1.489l-6.32 6.322a1.053 1.053 0 0 1-.759.323c-.302 0-.572-.125-.763-.323L.29 1.946A1.073 1.073 0 0 1 0 1.212 1.054 1.054 0 0 1 1.853.527l5.52 5.52z"
    />
  </svg>
);
